import * as React from 'react'
import Router from 'next/router'
import Layout from '../components/share/Layout'
import { WEB_DOMAIN } from '../const/domain'
import { TinTucService, SettingService, HeaderService } from '../services'
import { getIDSeoUrl, formatUrlSeo, notFoundUrl } from '../util/seo-url'
import { NEWS } from '../const/seo-url'
import ContentComponent from '../components/share/ContentComponent'
import { CONTENT } from '../const/content'
import { loadImage } from '../util/image'
import { DanhMucUtil } from '../util/danhmuc'
import { PageTransition } from "next-page-transitions";
import TinLienQuan from '../components/tin-tuc/TinLienQuan'
import FormDangKy from '../components/index/FormDangKy'
import { Fragment } from 'react'
import config from '../config/urlConfig';

function submitComment(tinTucId, comment) {
  return TinTucService.addComment(tinTucId, comment)
}

interface Props {
  domain
  title
  layoutProps
  numViewRandom
  tinTuc
}

interface State { }

export default class TinTuyenSinhDetail extends React.Component<any, any> {
  constructor(props) {
    super(props)
  }

  static async getInitialProps({ req, query }) {
    const layoutProps = await Layout.getInitialProps()
    const title = await SettingService.getSetting('title_tin_tuc')
    const host = req?.headers?.host || ''
    const protocol = (req as any)?.protocol || (req?.headers?.['x-forwarded-proto'] as string) || 'http'
    const originalUrl = (req as any)?.originalUrl || req?.url || ''
    let domain = `${protocol}://${host}${originalUrl}`

    let { url } = query
    if (!url || isNaN(Number(getIDSeoUrl(url))) || !getIDSeoUrl(url)) {
      return notFoundUrl(req);
    }
    const result = await TinTucService.getNewsByID(getIDSeoUrl(url))
    let tinTuc, files
    if (!result) {
      return notFoundUrl(req);
    } else {
      tinTuc = result.tinTuc
      files = result.files
    }

    return {
      tinTuc,
      files,
      domain: domain,
      title: title.value.value,
      layoutProps,
      numViewRandom: Math.floor(Math.random() * (500 + 9000) + 500),
    }
  }

  render() {
    let { tinTuc, files, domain } = this.props
    let url_seo_danh_muc = ''
    let tenDanhMuc = DanhMucUtil.getsNameByID(tinTuc.danhMucTinID, tinTuc.danhMucTen)
    if (tinTuc) {
      url_seo_danh_muc = formatUrlSeo(tenDanhMuc, tinTuc.danhMucTinID)
    }
    return (
      <React.Fragment>
        {!tinTuc ? (
          this.renderNotFound()
        ) : (
            <Layout
              title={`${this.props.title} - ${tinTuc.tieuDe}`}
              seo={tinTuc.seo}
              {...this.props.layoutProps}
            >
              {/* <PageTransition timeout={400} classNames="page-transition"> */}
                <div className="block back-tintuc" id="contentnews">
                  <div className="container">
                    <div className="news-title-detail text-pink text-center">
                      {tinTuc.tieuDe}
                    </div>
                    <div
                      className="news-content"
                      dangerouslySetInnerHTML={{ __html: tinTuc.noiDung }}
                    />
                    {files.length > 0 ? (
                    <div className="attachments">
                      <div className="attachcontent">
                        <strong>Attachments:</strong>
                        {files.map((data, index) => {
                          return <div className="filename" key={data.file_id}>
                            <a target='_blank' href={config.app.api_file_upload + data.path}>{data.file.name}</a>
                          </div>
                        })}

                      </div>
                    </div>
                    ) : ''}
                    <TinLienQuan tin_tuc_id={tinTuc.id} />
                  </div>
                  
                </div>
                
              {/* </PageTransition> */}
              <Fragment>
                  <FormDangKy />
              </Fragment>
              <style jsx global>
                {`
                .page-transition-enter {
                  opacity: 0;
                }
                .page-transition-enter-active {
                  opacity: 1;
                  transition: opacity ${400}ms;
                }
                .page-transition-exit {
                  opacity: 1;
                }
                .page-transition-exit-active {
                  opacity: 0;
                  transition: opacity ${400}ms;
                }
              `}
              </style>

            </Layout>
          )}
      </React.Fragment>
    )
  }

  public renderNotFound = () => {
    return (
      <Layout title={this.props.title} {...this.props.layoutProps}>
        <h1>Tin bạn tìm kiếm không tồn tại</h1>
      </Layout>
    )
  }
}
